import styled from "styled-components";

export const Tooltip = styled.div`
    position: absolute;
    bottom: 4px;
    right: 4px;
    cursor: pointer;
    &:hover {
        .Content {
            display: block;
        }
    }

    &.Select {
        right: 24px;
    }
`;

export const TooltipContainer = styled.div`
    background-color: ${p => p.theme.c.info};
    color: ${p => p.theme.c.whiteOnActive};
    width: 18px;
    height: 18px;
    border-radius: 10px;
    font-size: 14px;
    text-align: center;
    margin: 8px;
`;

export const TooltipContent = styled.div`
    display: none;
    position: absolute;
    right: 4px;
    top: 40px;
    background-color: ${p => p.theme.c.info};
    width: 260px;
    color: ${p => p.theme.c.whiteOnActive};
    border-radius: 4px;
    padding: 8px 10px;
    z-index: 10;
`;
